export default __webpack_public_path__ + "cb29e6611569412711d6cda6ee65ea79.svg";